const _SLICE_SZ = 5;
const _MAX_SZ = 10;

// generates a random string (max size 10)
// sample: "yr7k6"
function shortId(size = _SLICE_SZ) {
  const sliceSize = -1 * (size > _MAX_SZ ? _MAX_SZ : size);
  return Math.random().toString(36).slice(sliceSize);
}

export default shortId;
